import React, { FC } from 'react'
import { useForm } from 'react-hook-form'
import { Button, DrawerBody, DrawerFooter, DrawerHeader, Heading, Stack, Text } from '@chakra-ui/react'

import { CostCenterFilter } from 'InstitutionalManagement/types'
import CostCenterFilterForm from 'InstitutionalManagement/components/CostCenterFilterForm'
import { COST_CENTER_INITIAL_FILTER } from 'InstitutionalManagement/constants/pages/costCenters'
import { useCustomFormCostCenterSelectionDrawerManager } from '../../contexts/CustomFormCostCenterSelectionDrawerManager/Provider'
import CustomFormFilterWarningAlert from '../../../../components/CustomFormFilterWarningAlert'

type Props = {
  onClose: () => void
}

const SearchCostCenterOnCustomForm: FC<Props> = ({ onClose }) => {
  const { handleSubmit, register } = useForm<CostCenterFilter>({ defaultValues: COST_CENTER_INITIAL_FILTER })

  const { setView, filter, setFilter, setLoadingCostCenters } = useCustomFormCostCenterSelectionDrawerManager()

  function onSubmit(costCenterFilter: CostCenterFilter) {
    setFilter({ ...filter, ...costCenterFilter })
    setLoadingCostCenters(true)
    setView('SELECT_COST_CENTER')
  }

  return (
    <>
      <DrawerHeader>
        <Text>Selecionar um centro de custo</Text>
        <Heading color="primary">Pesquisar os centros de custo</Heading>
      </DrawerHeader>

      <DrawerBody>
        <Stack spacing={4}>
          <CustomFormFilterWarningAlert />

          <CostCenterFilterForm register={register} />
        </Stack>
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={onClose}>
          Fechar
        </Button>

        <Button onClick={() => handleSubmit(onSubmit)()}>Buscar centro de custo</Button>
      </DrawerFooter>
    </>
  )
}

export default SearchCostCenterOnCustomForm
